import React from 'react';
import { Dropdown } from '@praktio/common-ui';

import { DateFilterType } from '../../../utils/enums';
import { applyFilter } from '../../../utils/functions';
import { QuickFilterOptions, OneDay } from '../../../utils/constants';

import './QuickFilters.scss';

interface IProps {
  defaultFilters: IReportsFilterCategories; // The default filters applied, which are always set to no filters.
  appliedFilters?: IReportsFilterCategories;
  choices: string[];
  dropdownId: string;
  placeholderText: string;
  setAppliedFilters: React.Dispatch<React.SetStateAction<IReportsFilterCategories>>;
}

const Options = Object.keys(QuickFilterOptions).map((k) => ({
  id: k,
  label: QuickFilterOptions[k],
}));

const applyQuickFilter = ({
  setAppliedFilters,
  defaultFilters,
  quickFilterId,
}: {
  setAppliedFilters: React.Dispatch<React.SetStateAction<IReportsFilterCategories>>;
  defaultFilters: IReportsFilterCategories;
  quickFilterId: string;
}) => {
  // Setting a quick filter should clear all other filters,
  // even other quick filters.
  let displayStringToPass;
  let checkedValues;
  let filterType;
  let column = '';
  let endDate;
  let notEqual;
  let before;
  switch (QuickFilterOptions[quickFilterId]) {
    case QuickFilterOptions.NotCompletedCourse:
      displayStringToPass = '% Complete';
      checkedValues = [
        {
          displayString: 'Less than 100.00%',
          comparisonValue: '100.00%',
        },
      ];
      filterType = 'string';
      column = 'progressFormatted';
      notEqual = true;
      break;
    case QuickFilterOptions.NotLoggedIn:
      displayStringToPass = 'Last Login';
      checkedValues = DateFilterType.blankOnly;
      filterType = 'date';
      column = 'lastLoginLocal';
      break;
    case QuickFilterOptions.NotLoggedInTwoWeeks:
      const twoWeeks = OneDay * 14;
      const now = new Date();
      const twoWeeksAgo = new Date(now.getTime() - twoWeeks);
      displayStringToPass = 'Last Login';
      checkedValues = DateFilterType.range;
      endDate = twoWeeksAgo;
      filterType = 'date';
      column = 'lastLoginLocal';
      before = true;
      break;
    case QuickFilterOptions.CompletedCourse:
      displayStringToPass = '% Complete';
      checkedValues = [
        {
          displayString: '100.00%',
          comparisonValue: '100.00%',
        },
      ];
      filterType = 'string';
      column = 'progressFormatted';
      break;
  }
  applyFilter({
    displayString: displayStringToPass,
    checkedValues,
    filterType,
    column,
    setAppliedFilters,
    appliedFilters: defaultFilters,
    notEqual,
    endDate,
    before,
    quickFilterId,
  });
};

export const QuickFilters = ({
  defaultFilters,
  appliedFilters,
  choices,
  dropdownId = 'dropdown-id',
  placeholderText = 'Placeholder',
  setAppliedFilters,
}: IProps) => {
  let selectedQuickFilterId: string | undefined;
  Object.values(appliedFilters || {}).forEach((f) =>
    !!f.quickFilterId ? (selectedQuickFilterId = f.quickFilterId) : undefined,
  );
  return (
    <Dropdown
      id="quick-filters"
      options={Options}
      onSelect={(id) => {
        if (id) {
          applyQuickFilter({ setAppliedFilters, defaultFilters, quickFilterId: id });
        }
      }}
      value={Options.find((o) => o.id === selectedQuickFilterId)}
      placeholder="Quick Filters"
    />
  );
};
